import { createFileRoute } from '@tanstack/react-router';

// The parent validates the bounded legacy path and resolves authorization before redirecting.
export const Route = createFileRoute('/$locale/_authenticated/crm/customers/$customerId/$')({});
